import { Box, Button, Typography } from "@mui/material";
import Flex from "../../../../../../../../components/Flex";
import StyledDialog from "../../../../../../../../components/StyledDialog";
import { DisclosureHost } from "../../../../../../../../hooks/use-disclosure";
import { CHART_COLORS } from "../../../../../../../../components/app/provider/patient/chart";

interface InsuranceCardPreviewModalProps {
  disclosureHost: DisclosureHost;
}

const InsuranceCardPreviewModal = ({
  disclosureHost,
}: InsuranceCardPreviewModalProps) => {
  const item = disclosureHost.data;

  const photos = [
    { label: "Front", url: item?.frontPhoto },
    { label: "Back", url: item?.backPhoto },
  ].filter((photo) => !!photo.url);

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle="Insurance Card"
      dialogAction={
        <Button variant="contained" onClick={disclosureHost.close}>
          Close
        </Button>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: "80vw",
          maxWidth: "900px",
        },
      }}
    >
      <Flex gap="24px" justifyContent="center" flexWrap="wrap">
        {photos.map((photo) => (
          <Flex
            key={photo.label}
            flexDirection="column"
            gap="8px"
            alignItems="center"
          >
            <Typography fontSize="14px" fontWeight="medium">
              {photo.label}
            </Typography>
            <Box
              component="img"
              src={photo.url}
              alt={`Insurance card ${photo.label.toLowerCase()}`}
              sx={{
                maxWidth: "100%",
                maxHeight: "60vh",
                objectFit: "contain",
                borderRadius: "12px",
                border: `1px solid ${CHART_COLORS.border}`,
              }}
            />
          </Flex>
        ))}
      </Flex>
    </StyledDialog>
  );
};

export default InsuranceCardPreviewModal;
